import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=3e1d4e49&scoped=true&"
import script from "./SpinnerLoader.vue?vue&type=script&lang=ts&"
export * from "./SpinnerLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=3e1d4e49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1d4e49",
  null
  
)

export default component.exports